module.exports = __webpack_public_path__ + "assets/img/6.2031def8.png";